import { render, staticRenderFns } from "./VeHrEmployeePayrollList.vue?vue&type=template&id=224badb9&scoped=true"
import script from "./VeHrEmployeePayrollList.vue?vue&type=script&lang=js"
export * from "./VeHrEmployeePayrollList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224badb9",
  null
  
)

export default component.exports